import { getToken, isSupported, Messaging } from "firebase/messaging";
import { messaging } from "../firebase/firebase";
import { notifyError } from "./NotifyError";
import { IError } from "./getErrorMessage";
import { urlBase64ToUint8Array } from "./urlBase64ToUnit8Array";

export const subscribeFirebase = async () => {
	try {
		if (!("Notification" in window)) {
			notifyError({ error: "Notification is not available" } as IError);
			return null;
		}

		const permission = await Notification.requestPermission();
		if (permission !== "granted") {
			console.warn("Permission denied");
			notifyError({ error: "Permission denied" } as IError);
			return null;
		}
		const supported = await isSupported();

		if (!supported) {
			console.warn("Browser not supported");
			notifyError({ error: "Browser not supported" } as IError);
			return null;
		}

		const token = await getToken(messaging as Messaging, {
			vapidKey: process.env.REACT_APP_VAPID
		});

		return token;
	} catch (error) {
		notifyError(error as IError);
	}
};

export const subscribeAppleWebPush = async () => {
	try {
		if (!("Notification" in window)) {
			notifyError({ error: "Notification is not available" } as IError);
			return null;
		}

		const permission = await Notification.requestPermission();
		console.log(permission);
		if (permission !== "granted") {
			console.warn("Permission denied");
			notifyError({ error: "Permission not granted" } as IError);
			return null;
		}
		console.log("service worker registration");
		const registration = await navigator.serviceWorker.ready;
		console.log(registration);
		console.log(process.env.REACT_APP_VAPID_IOS);
		return registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_IOS || "")
		});
	} catch (error) {
		notifyError(error as IError);
	}
};
